module.exports = __webpack_public_path__ + "html/opportunity-form.component.html";